import MenuIcon from "@/assets/icons/map/menu.svg?react"
import MapIcon from "@/assets/icons/map/map.svg?react"
import BellIcon from "@/assets/icons/map/bell.svg?react"

export const options = [
  {
    label: "Menu",
    icon: MenuIcon
  },
  {
    label: "Map",
    icon: MapIcon
  },
  {
    label: "Notifications",
    icon: BellIcon
  }
]

export const footerStyles = {
  xs: {
    container: {
      padding: "2px 8px"
    },
    top: {
      marginBottom: "2px"
    },
    optionContainer: {
      width: "26px"
    },
    optionLabel: {
      fontSize: "0.1875rem !important"
    },
    bottom: {
      width: "38px"
    }
  },
  md: {
    container: {
      padding: "5px 20px"
    },
    top: {
      marginBottom: "5px"
    },
    optionContainer: {
      width: "62px"
    },
    optionLabel: {
      fontSize: "0.5rem !important"
    },
    bottom: {
      width: "88px"
    }
  }
}